(() => {
  const activeRequests = new WeakMap();

  document.addEventListener('change', async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const picker = target.closest('variant-picker');
    if (!picker) return;

    const selectedOption =
      target instanceof HTMLSelectElement
        ? target.options[target.selectedIndex]
        : target;

    const variantId = selectedOption?.dataset?.variantId;
    if (!variantId) return;

    const section = picker.closest('.shopify-section');
    const card = section?.querySelector('[data-amazon-stock-card]');
    if (!section || !card) return;

    const productUrl = card.dataset.productUrl;
    const sectionId = section.id.replace(/^shopify-section-/, '');
    if (!productUrl || !sectionId) return;

    activeRequests.get(card)?.abort();

    const controller = new AbortController();
    activeRequests.set(card, controller);

    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url, {
        signal: controller.signal,
        headers: { Accept: 'text/html' },
      });

      if (!response.ok) return;

      const html = new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      );

      const updatedCard = html.querySelector('[data-amazon-stock-card]');
      if (updatedCard) card.replaceWith(updatedCard);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Could not update the stock card:', error);
      }
    }
  });
})();
